import script from "./Talent_Items.vue?vue&type=script&setup=true&lang=ts"
export * from "./Talent_Items.vue?vue&type=script&setup=true&lang=ts"

import "./Talent_Items.vue?vue&type=style&index=0&id=6e9a2bd0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e9a2bd0"]])

export default __exports__